import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Flex from '../atoms/Flex';
import LegendItem from './LegendItem';
import { getAppTheme } from '../../services/appTheme';
const StyledFlex = styled(Flex) `
    flex-wrap: wrap;

    @media only screen and (min-width: 992px) {
        flex-wrap: nowrap;
        margin-bottom: 60px;
    }
`;
const ChartLegend = () => {
    return (_jsxs(StyledFlex, { children: [_jsx(LegendItem, { color: getAppTheme().chart.colors[0], label: "Openstaand saldo" }), _jsx(LegendItem, { color: getAppTheme().chart.colors[1], label: "Aantal lopende zaken" })] }));
};
export default ChartLegend;
